"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clc = require("cli-color");
var EZuntaLoggerType;
(function (EZuntaLoggerType) {
    EZuntaLoggerType["LOG"] = "LOG";
    EZuntaLoggerType["ERROR"] = "ERROR";
    EZuntaLoggerType["WARN"] = "WARN";
    EZuntaLoggerType["DEBUG"] = "DEBUG";
})(EZuntaLoggerType || (EZuntaLoggerType = {}));
// example: [LOG] 16:43:22 [DepositsController] Deposits pushed
// example: [ERROR] 16:43:22 [AuthController.login()] Can not read property length of "undefined"
class Logger {
    constructor(context) {
        this.context = context;
    }
    static formatMsgAndLog(type = EZuntaLoggerType.LOG, message = "", context, location) {
        const typeFormatted = Logger.colorMsgOrType(type);
        const contextMessage = clc.yellow(location ? `${context}.${location}()` : context);
        const timestamp = (Logger.getTime());
        if (type === EZuntaLoggerType.ERROR) {
            console.log(`[${typeFormatted}] ${timestamp} [${contextMessage}]`, message);
        }
        else {
            console.log(`[${typeFormatted}] ${timestamp} [${contextMessage}]`, message);
        }
    }
    static colorMsgOrType(type, msg) {
        switch (type) {
            case EZuntaLoggerType.LOG:
                return clc.green(msg || type);
            case EZuntaLoggerType.DEBUG:
                return clc.magentaBright(msg || type);
            case EZuntaLoggerType.WARN:
                return clc.yellow(msg || type);
            case EZuntaLoggerType.ERROR:
                return clc.red(msg || type);
            default:
                return msg || type;
        }
    }
    static getTime() {
        return new Date().toLocaleString();
    }
    static formatErrorMsg(error) {
        let msgToDisplay = {};
        // @ts-ignore
        if (error && typeof error === 'object' && "name" in error && error.name === 'QueryFailedError') {
            error.name && (msgToDisplay.name = error.name);
            error.message && (msgToDisplay.message = error.message);
            error.query && (msgToDisplay.query = error.query);
            error.parameters && (msgToDisplay.parameters = error.parameters);
            error.detail && (msgToDisplay.detail = error.detail);
        }
        else if (error instanceof Error) {
            msgToDisplay = error.message;
        }
        else {
            msgToDisplay = error;
        }
        return msgToDisplay;
    }
    log(message, location) {
        Logger.formatMsgAndLog(EZuntaLoggerType.LOG, message, this.context, location);
    }
    static log(message, context, location) {
        Logger.formatMsgAndLog(EZuntaLoggerType.LOG, message, context, location);
    }
    error(message, location) {
        const msgToDisplay = Logger.formatErrorMsg(message);
        Logger.formatMsgAndLog(EZuntaLoggerType.ERROR, msgToDisplay, this.context, location);
    }
    static error(message, context, location) {
        const msgToDisplay = Logger.formatErrorMsg(message);
        Logger.formatMsgAndLog(EZuntaLoggerType.ERROR, msgToDisplay, context, location);
    }
    warn(message, location) {
        Logger.formatMsgAndLog(EZuntaLoggerType.WARN, message, this.context, location);
    }
    static warn(message, context, location) {
        Logger.formatMsgAndLog(EZuntaLoggerType.WARN, message, context, location);
    }
    debug(message, location) {
        Logger.formatMsgAndLog(EZuntaLoggerType.DEBUG, message, this.context, location);
    }
    static debug(message, context, location) {
        Logger.formatMsgAndLog(EZuntaLoggerType.DEBUG, message, context, location);
    }
}
exports.Logger = Logger;
